import React from 'react';
import autobind from 'core-decorators/lib/autobind';

import attachScript from '@wix/wix-vod-shared/src/common/utils/attach-script';
import PropTypes from 'prop-types';
import { stringify } from '@wix/wix-vod-shared/src/common/utils/query-string';


const scriptApiUrl = 'https://player.vimeo.com/api/player.js';
const DEFAULT_VOLUME = 1;

let scriptPromise = null;


export default class VimeoExternal extends React.Component {

  static propTypes = {
    src: PropTypes.string.isRequired,

    onPlay: PropTypes.func,
    onPause: PropTypes.func,
    onEnd: PropTypes.func,
    onIframeRef: PropTypes.func.isRequired,

    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,

    simple: PropTypes.bool,
    mobileMode: PropTypes.bool,

    isVideoPlayRequested: PropTypes.bool,
    isVideoPauseRequested: PropTypes.bool,
    isVideoPlaying: PropTypes.bool,
    isVideoPaused: PropTypes.bool,

    loop: PropTypes.bool,
    muted: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.player = null;
    this.iframeRef = null;
    this.__volume = 0;

    // load once
    scriptPromise = scriptPromise || attachScript(scriptApiUrl);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.src === this.props.src) {
      this.setSettings(nextProps, this.props);
    }
  }

  componentWillUnmount() {
    if (this.player) {
      this.detachEventsFromPlayer();
    }
  }

  attachEventsToPlayer() {
    const { onPlay, onPause, onEnd } = this.props;

    this.player.on('play', onPlay);
    this.player.on('pause', onPause);
    this.player.on('ended', onEnd);
  }

  detachEventsFromPlayer() {
    const { onPlay, onPause, onEnd } = this.props;

    this.player.off('play', onPlay);
    this.player.off('pause', onPause);
    this.player.off('ended', onEnd);
  }

  setSettings({ isVideoPlayRequested, isVideoPauseRequested, loop, muted }, prevProps = {}) {
    if (!this.player) {
      return null;
    }

    if (prevProps.isVideoPlayRequested !== isVideoPlayRequested && isVideoPlayRequested) {
      this.togglePaused(false);
    }

    if (prevProps.isVideoPauseRequested !== isVideoPauseRequested && isVideoPauseRequested) {
      this.togglePaused(true);
    }

    this.toggleLoop(loop);
    this.toggleMute(muted);
  }

  togglePaused(paused) {
    this.player
      .getPaused()
      .then(currentPaused => {
        if (paused && !currentPaused) {
          this.player.pause();
        }

        if (!paused && currentPaused) {
          this.player.play();
        }
      });
  }

  toggleLoop(loop) {
    if (loop) {
      this.player.setLoop(true);
    } else {
      this.player.setLoop(false);
    }
  }

  toggleMute(muted) {
    if (muted) {
      this.player.getVolume()
        .then(volume => {
          this.__volume = volume;
        });
      this.player.setVolume(0);
    } else {
      const volume = this.__volume === 0 ? DEFAULT_VOLUME : this.__volume;
      this.player.setVolume(volume);
      this.__volume = 0;
    }
  }

  getIframeSrcUrl() {
    const { src, simple, mobileMode } = this.props;
    const query = {};

    if (simple || mobileMode) {
      query.badge = '0';
      query.portrait = '0';
      query.title = '0';
    }

    return `${src}${stringify(query)}`;
  }

  @autobind
  onReady() {
    this.player = new window.Vimeo.Player(this.iframeRef);
    this.attachEventsToPlayer();

    this.setSettings(this.props);
  }

  @autobind
  saveIframeRef(ref) {
    if (!ref) {
      this.player = null;
      return;
    }

    this.iframeRef = ref;
    this.props.onIframeRef(ref);

    scriptPromise
      .then(this.onReady);
  }

  render() {
    const props = _.pick(this.props, 'className', 'width', 'height');
    const { isVideoPauseRequested, isVideoPlayRequested, isVideoPlaying, isVideoPaused } = this.props;
    const tabIndex = isVideoPauseRequested || isVideoPlayRequested || isVideoPlaying || isVideoPaused ? 0 : -1;

    return (
      <iframe {...props}
              src={this.getIframeSrcUrl()}
              frameBorder="0"
              allowFullScreen
              tabIndex={tabIndex}
              ref={this.saveIframeRef} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/external/vimeo.js